import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import LegalContent from "../components/legal/legalContent"

export const DisclosurePageTemplate = ({
  data: {
    markdownRemark: {
      frontmatter: { slug, title, description, copy },
    },
  },
}) => {
  return (
    <Layout>
      <SEO title={title} description={description} pathname={slug} />
      <LegalContent copy={copy} />
    </Layout>
  )
}

export default DisclosurePageTemplate

export const pageQuery = graphql`
  query DisclosurePageTemplate {
    markdownRemark(frontmatter: { templateKey: { eq: "disclosure-page" } }) {
      frontmatter {
        slug
        title
        description
        copy
      }
    }
  }
`
